import { Utilities } from '@microsoft/office-js-helpers'

import { getAccessToken } from './nested-app-auth/authHelper'
import { captureException } from '../sentry-config'

export default class OutlookMailbox {
  constructor(office) {
    this.office = office
  }

  token = async () => {
    try {
      return await getAccessToken(['user.read', 'offline_access'])
    } catch (error) {
      console.error('NAA token error: ', error)
      captureException(error, {
        fingerprint: ['OutlookMailbox#token'],
        extra: {
          message: error.message,
          code: error.code,
          traceMessages: error.traceMessages || [],
        },
      })
      return null
    }
  }

  get mailbox() {
    return this.office.context.mailbox
  }

  get platform() {
    return Utilities.platform
  }

  async restConnection() {
    return {
      restUrl: this.mailbox.restUrl,
      restToken: await this.token(),
    }
  }

  getAppDisplayLanguage() {
    return this.office.context.displayLanguage
  }
}
